export default "__VITE_ASSET__a182f56d__"